/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import {
  TESTIMONIAL_DISPLAY_STYLES$1 as TESTIMONIAL_DISPLAY_STYLES,
  TestimonialItem,
  TestimonialsModule,
} from '@coursera-web/cds-labs';

import { getTestimonialsRedesign } from 'bundles/coursera-plus-landing-page/constants/peopleData';

import _t from 'i18n!nls/coursera-plus-landing-page';

const styles = {
  container: css`
    h2 {
      margin-bottom: var(--cds-spacing-400);
    }
  `,
};

const CourseraPlusTestimonials = () => {
  const heading = _t('What subscribers are achieving through learning');
  const testimonials = getTestimonialsRedesign();
  return (
    <div css={styles.container}>
      <TestimonialsModule
        headline={heading}
        testimonialItems={testimonials.map(({ id, authorName, quote, learnerSince, image }, index) => (
          <TestimonialItem
            key={id}
            name={authorName}
            quote={quote}
            learnerSince={learnerSince}
            imageSrc={image?.url}
            trackingIndex={index}
          />
        ))}
        numTestimonialsToDisplay={Math.min(testimonials.length, 4) as 1 | 2 | 3 | 4}
        displayStyle={TESTIMONIAL_DISPLAY_STYLES.CARDS}
      />
    </div>
  );
};

export default CourseraPlusTestimonials;
